import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>Copyright © Nexceed Innovations Pvt Ltd 2026</p>
      </div>
    </div>
  );
};

export default Footer;
